import { ReactElement } from "react";
import { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

const AlertHat = ({
  height = "24px",
  width = "24px"
}: IconProps): ReactElement => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 16 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11908_3597)" id="Alert Icon">
        <path
          d="M8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16Z"
          fill="#6E0000"
          id="Vector"
        />
        <path
          clipRule="evenodd"
          d="M7.66748 3.90627C7.81336 3.83333 7.98507 3.83333 8.13098 3.90627L13.3027 6.49217C13.3683 6.52322 13.4263 6.56762 13.4731 6.62185C13.5517 6.71269 13.5992 6.83113 13.5992 6.96065V10.0697C13.5992 10.356 13.3672 10.588 13.0811 10.588C12.7948 10.588 12.5628 10.356 12.5628 10.0697V7.79909L8.13098 10.0151C7.98507 10.088 7.81336 10.088 7.66748 10.0151L2.48566 7.42413C2.31011 7.33636 2.19922 7.15693 2.19922 6.96065C2.19922 6.76438 2.31011 6.58496 2.48566 6.49718L7.66748 3.90627ZM11.9223 6.96065L7.89922 4.94909L3.87609 6.96065L7.89922 8.9722L11.9223 6.96065Z"
          fill="white"
          fillRule="evenodd"
          id="Vector_2"
        />
        <path
          clipRule="evenodd"
          d="M4.79162 7.47949C5.07781 7.47949 5.30981 7.71148 5.30981 7.99767V10.3632C5.96739 10.9309 6.91624 11.2363 7.90071 11.2363C8.88521 11.2363 9.83401 10.9309 10.4916 10.3632V7.99767C10.4916 7.71148 10.7236 7.47949 11.0098 7.47949C11.296 7.47949 11.528 7.71148 11.528 7.99767V10.5886C11.528 10.726 11.4734 10.8578 11.3762 10.955C10.4798 11.8514 9.16945 12.2727 7.90071 12.2727C6.63196 12.2727 5.32165 11.8514 4.42521 10.955C4.32803 10.8578 4.27344 10.726 4.27344 10.5886V7.99767C4.27344 7.71148 4.50544 7.47949 4.79162 7.47949Z"
          fill="white"
          fillRule="evenodd"
          id="Vector_3"
        />
      </g>
      <defs>
        <clipPath id="clip0_11908_3597">
          <rect fill="white" height={height} width={width} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlertHat;
